import { unref } from "vue";
import { sortRecords } from "@/util/recordUtils.js";
import { mapItemToRecord } from "@/components/CategoryLayouts/mapItemToRecord.ts";

export function categoryDocumentToRecordColumns(possiblyCategoryRef) {
  const category = unref(possiblyCategoryRef);
  if (!category || !category.entries) return [];
  const columns = category.recordColumns ?? [];

  return columns.map((recordColumn) => {
    let sortedRecords = sortRecords(
      recordColumn,
      (category.entries ?? [])
        .filter(
          (entryItem) =>
            entryItem.recordInfo?.columnID === recordColumn.columnID
        )
        .map((entryItem, index) =>
          mapItemToRecord(entryItem, recordColumn, index)
        )
    );

    // Reassign rank after sorting
    if (recordColumn.recordSortDirection === "custom") {
      sortedRecords = sortedRecords.map((record, index) => ({
        ...record,
        rank: index + 1,
      }));
    } else {
      let lastValue;
      let lastRank = 0;
      const isDateSort =
        recordColumn.recordSortDirection === "oldest" ||
        recordColumn.recordSortDirection === "newest";
      sortedRecords = sortedRecords.map((record, index) => {
        if (index === 0) {
          lastValue = isDateSort ? record.recordInfo.recordDate : record.value;
          lastRank = 1;
          return { ...record, rank: 1 };
        }

        if (
          (isDateSort && record.recordInfo.recordDate === lastValue) ||
          record.value === lastValue
        ) {
          return { ...record, rank: lastRank };
        }

        lastValue = isDateSort ? record.recordInfo.recordDate : record.value;
        lastRank = index + 1;
        return { ...record, rank: lastRank };
      });
    }

    return {
      ...recordColumn,
      _id: recordColumn.columnID,
      title: recordColumn.recordLabel ?? "",
      recordSortDirection: recordColumn.recordSortDirection,
      records: sortedRecords,
    };
  });
}
